<template>
  <app-layout title="Subscription">
    <PageTitle :headerTitle="title"> </PageTitle>
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="container bg-white shadow-sm w-20 p-2">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center bg-green-400 text-white p-2 orderMessageSuccess" style="display:none;">Order Successful</div>
            <div class="text-center bg-red-400 text-white p-2 orderMessageFailure" style="display:none;">Order Failed</div>
            <label for="subscription-select">Choose a subscription:</label><br>

            <select name="subscription" id="subscription-select" @change="onChange($event)">
                <option value="no_selected">--Please choose an option--</option>
                <option value="six_mon">6 Months</option>
                <option value="one_yr">1 Year</option>
                <option value="two_yr">2 Year</option>
            </select>
            <br>
            <br>

            <!-- Summary - START -->
            <div class="row">
            <div class="col-lg-6">
            <h4>Payment details</h4>
                        <table width="100%" style="border-collapse: collapse;">
                            <tr>
                                <td class="column-title">Subscription
                                </td>
                                <td class="column-subscription" id="subscription">{{selectedSubscription}}
                                </td>
                            </tr>
                            <tr>
                                <td width="180px" class="column-title">Price
                                </td>
                                <td class="column-price" id="price">{{selectedSubscriptionPrice}}
                                </td>
                            </tr>
                            <tr>
                                <td class="column-title font-semibold">GST<span class="text-xs">(18%)</span>
                                </td>
                                <td class="column-subscription font-semibold" id="gst">{{gst}}
                                </td>
                            </tr>
                        </table>
                        <hr>
                        <table width="100%" style="border-collapse: collapse;">
                            <tr>
                                <td width="180px" class="column-title font-semibold">Total
                                </td>
                                <td class="column-price font-semibold" id="total">{{total}}
                                </td>
                            </tr>
                        </table>

                        </div>
                        <div class="col-lg-6">
                          <h4>Your contact details</h4>
                        <table width="100%" style="border-collapse: collapse;">
                            <tr>
                                <td width="180px" class="column-title">Name
                                </td>
                                <td class="column-detail">Some Name
                                </td>
                            </tr>
                            <tr>
                                <td class="column-title">E-mail
                                </td>
                                <td class="column-detail">some@name.com
                                </td>
                            </tr>
                            <tr>
                                <td class="column-title">Organisation
                                </td>
                                <td class="column-detail">Tenant Name
                                </td>
                            </tr>
                            <tr>
                                <td class="column-title">GST
                                </td>
                                <td class="column-detail">GSTNUMBER000000
                                </td>
                            </tr>
                            <tr>
                                <td class="column-title">PAN
                                </td>
                                <td class="column-detail">PANNUMBER0
                                </td>
                            </tr>
                        </table>
            
                        </div>
                        </div>
                        <br>
                       
            <!-- Summary - END -->

                  <div v-on:click="startPayment()" class="col-4 px-2 mr-1 ml-1 cursor-pointer text-white bg-green-500 rounded text-lg text-center hover:no-underline">
                    Proceed
                  </div>
          </div>
        </div>
      </div>
    </div>    
  </app-layout>
</template>
<style>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }

    .img-company {
        width: 50px;
        height: 50px;
    }

    .no-decoration{
      text-decoration: none;
    }

    .no-decoration:hover{
      text-decoration: none;
    }



    .organisations-container {
        width: 50% !important;
        background: var(--white);
    }

    .ul-add-organisation {
        background-color: var(--blue);
    }


    .btn-submit {
        background-color: var(--blue);
    }
    
    </style>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from '@/Jetstream/NavLink.vue'


export default {
  props: ["sessions"],

  components: {
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,

  },
  data() {
    return {
      tenantData: null,
      productData:null,
      title: "Subscription",
      productId:"",
      organisationId:"",
      selectedSubscription:"--",
      selectedSubscriptionPrice:"--",
      amount:0,
      total:"--",
      gst:"18%",
    };
  },
  methods: {
    onChange(event) {
      if (event.target.value==="no_selected"){
        this.selectedSubscription="--";
        this.selectedSubscriptionPrice="--";
        this.total="--";
        this.gst="18%";
        this.amount=0;
      }
      else if (event.target.value==="six_mon"){
        this.selectedSubscription="6 Months";
        this.selectedSubscriptionPrice="₹ 2000";
        this.total="₹ 2360";
        this.amount=2360*100;
        this.gst="₹ 360";
      }
      else if (event.target.value==="one_yr"){
        this.selectedSubscription="1 Year";
        this.selectedSubscriptionPrice="₹ 3500";
        this.total="₹ 4130";
        this.amount=4130*100;
        this.gst="₹ 630";
      }
      else if (event.target.value==="two_yr"){
        this.selectedSubscription="2 Year";
        this.selectedSubscriptionPrice="₹ 6000";
        this.total="₹ 7080";
        this.amount=7080*100;
        this.gst="₹ 1080";
      }
        },
    initParams() {
       let urlParams = new URLSearchParams(window.location.search);
      this.productId=urlParams.get('product_id');
      this.organisationId=urlParams.get('organisation_id');
    },
    startPayment(){
      var options = {
        "key": "rzp_test_aVB7oQHjVoZvN3", // Enter the Key ID generated from the Dashboard
        "amount": this.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        "currency": "INR",
        "name": "Aruvaa",
        "description": "Test Transaction",
        "image": "imgs/aruvaa_logo.png",
        // "order_id": "order_HWOJLACifNfmWO", //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
        "handler": function(response) {
          // make network call and send the response values to server
             axios.get("tenants/list").then((response) => {
                console.log(response.data.results.data);

                document.querySelector('.orderMessageSuccess').style.display = 'block';
                document.querySelector('.orderMessageFailure').style.display = 'none';
                setTimeout(() => window.location.href = "/dashboard", 2000);
                
              });
        },
        "prefill": {
            "name": "Some Username",
            "email": "username@example.com",
            "contact": "9999999999"
        },
        "notes": {
            "address": "Razorpay Corporate Office"
        },
        "theme": {
            "color": "#3399cc"
        }
    };

  var rzp1 = new Razorpay(options);
    rzp1.on('payment.failed', function(response) {
    alert(response.error.code);
    alert(response.error.description);
    alert(response.error.source);
    alert(response.error.step);
    alert(response.error.reason);
    alert(response.error.metadata.order_id);
    alert(response.error.metadata.payment_id);
     document.querySelector('.orderMessageSuccess').style.display = 'none';
     document.querySelector('.orderMessageFailure').style.display = 'block';

});

    rzp1.open();

},
    savePaymentsInfo() {
       let urlParams = new URLSearchParams(window.location.search);
      this.productId=urlParams.get('product_id');
      this.organisationId=urlParams.get('organisation_id');
      axios.get("tenants/list").then((response) => {
        this.tenantData = response.data.results.data;
      });
    },
    
  },
  mounted() {
    this.initParams();
  },
};
</script>
